exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a2a_kit a[data-v-70b10598]{transition:transform .2s ease}.a2a_kit a[data-v-70b10598]:hover{transform:scale(1.05)}", ""]);

// exports
